import { render, staticRenderFns } from "./confirmAccount.vue?vue&type=template&id=3a3448b9&scoped=true"
import script from "./confirmAccount.vue?vue&type=script&lang=js"
export * from "./confirmAccount.vue?vue&type=script&lang=js"
import style0 from "./confirmAccount.vue?vue&type=style&index=0&id=3a3448b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3448b9",
  null
  
)

export default component.exports